module.exports = __webpack_public_path__ + "static/user-story_vertical-87bf763cd32a5e4c003e6df5c28a7a37.png";